import { Box } from '@mui/material';
import React from 'react';
import { useDispatch } from 'react-redux';
import UserProfile from './UserProfile';
import MainContentLayout from '../../components/Layout/MainContentLayout';

const LoggedUserProfile = () => {
    const menuDispatch = useDispatch();
    menuDispatch({
        type: 'menuSelect',
        payload: 'logged-user-profile'
    });
  return (
    <UserProfile />
  );
}

export default LoggedUserProfile;
